(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/assets/javascripts/pages/page-play.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/assets/javascripts/pages/page-play.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useContext = _React.useContext,
  useState = _React.useState;
const initClient = svs.oddset_kambi.initClient;
const MaintenanceContext = svs.oddset_kambi.components.maintenance_context.MaintenanceContext;
const NavContext = svs.oddset_kambi.components.nav_context.NavContext;
const SportradarStatisticsIframe = svs.oddset_kambi.components.sportradar_statistics.SportradarStatisticsIframe;
const widgetEvents = svs.oddset_kambi.components.widgetEvents;
const KambiWidgetEvents = svs.oddset_kambi.components.common.constants.KambiWidgetEvents;
const BetsContext = svs.oddset_kambi.components.bets_context.BetsContext;
const setupWapiSubscription = svs.oddset_kambi.components.wapiIntegration.setupWapiSubscription;
const PlayPage = () => {
  const _useContext = useContext(MaintenanceContext),
    setKambiMaintenance = _useContext.setKambiMaintenance;
  const _useContext2 = useContext(NavContext),
    setActivePathname = _useContext2.setActivePathname;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    betradarId = _useState2[0],
    setBetradarId = _useState2[1];
  const _useContext3 = useContext(BetsContext),
    refreshPendingBets = _useContext3.refreshPendingBets,
    refreshPendingBetsThrottled = _useContext3.refreshPendingBetsThrottled,
    setNumPendingBets = _useContext3.setNumPendingBets;
  useEffect(() => {
    if (!window.hasInitialized) {
      initClient({
        setKambiMaintenance,
        setActivePathname,
        refreshPendingBets,
        refreshPendingBetsThrottled,
        setBetradarId
      });
      window.hasInitialized = true;
    }
    const kambiContainerElement = document.querySelector('#KambiBC');
    kambiContainerElement.classList.remove('kambi-hidden');
    return () => {
      kambiContainerElement.classList.add('kambi-hidden');
    };
  }, [setKambiMaintenance, setActivePathname, refreshPendingBets, refreshPendingBetsThrottled]);
  useEffect(() => {
    const handleSetBetradarId = event => {
      setBetradarId(event.detail.betRadarId);
    };
    widgetEvents.addEventListener(KambiWidgetEvents.SET_BETRADAR_ID, handleSetBetradarId);
    return () => {
      widgetEvents.removeEventListener(KambiWidgetEvents.SET_BETRADAR_ID, handleSetBetradarId);
    };
  }, []);
  useEffect(() => {
    let subscription;
    let hasUnmounted = false;
    const setupSubscription = async () => {
      const wapi = await window.KambiWidget.ready;
      if (hasUnmounted) {
        return;
      }
      subscription = setupWapiSubscription({
        setNumPendingBets
      }, wapi);
    };
    setupSubscription();
    return () => {
      hasUnmounted = true;
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, [setNumPendingBets]);
  if (betradarId) {
    return React.createElement(SportradarStatisticsIframe, {
      betradarId: betradarId,
      closeModal: () => setBetradarId(null)
    });
  }
  return null; 
};
setGlobal('svs.oddset_kambi.pages.PlayPage', PlayPage);

 })(window);